import { Check } from "lucide-react";

export function CardSetupFacts({ businessName }: { businessName: string }) {
  const facts = [
    { text: "No charge today" },
    { text: "Stored securely by Stripe" },
    { text: `Card details are not visible to ${businessName}`, personal: true },
    { text: `Only ${businessName} can use it`, personal: true },
  ];
  return (
    <ul aria-label="About saving your card" className="mx-5 mt-5 space-y-1.5 lg:mx-0 lg:mt-0">
      {facts.map(fact => (
        <li key={fact.text} className="flex items-center gap-2.5 text-[15px] font-semibold leading-snug">
          <span aria-hidden className="grid size-5 shrink-0 place-items-center rounded-full bg-primary text-primary-foreground lg:bg-matcha lg:text-primary">
            <Check className="size-3" strokeWidth={3.5} />
          </span>
          <span data-telemetry-mask={fact.personal || undefined}>{fact.text}</span>
        </li>
      ))}
    </ul>
  );
}
